import { commentItems } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            用户热议
          </h2>
          <div className="mt-4 w-16 h-1 bg-accent-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">看看大家都在说什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-[960px] mx-auto">
          {commentItems.map((comment, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-accent-300/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div>
                  <span className="block text-sm font-semibold text-foreground-900">{comment.name}</span>
                  <span className="block text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{comment.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}